const TYPES = {
    GET_PRIZES: 'GET_PRIZES',
    GET_PRIZES_SUCCESS: 'GET_PRIZES_SUCCESS',
    GET_PRIZES_FAILED: 'GET_PRIZES_FAILED'
};

export default {
    TYPES,
    getPrizes: payload => {
        return {
            type: TYPES.GET_PRIZES,
            payload
        };
    },
    getPrizesSuccess: resp => {
        return {
            type: TYPES.GET_PRIZES_SUCCESS,
            payload: {resp}
        };
    },
    getPrizesFailed: error => {
        return {
            type: TYPES.GET_PRIZES_FAILED,
            payload: {error}
        };
    }
};
